import { render, staticRenderFns } from "./NotConnected.vue?vue&type=template&id=5ba55864&"
import script from "./NotConnected.vue?vue&type=script&lang=js&"
export * from "./NotConnected.vue?vue&type=script&lang=js&"
import style0 from "./NotConnected.vue?vue&type=style&index=0&id=5ba55864&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../kiwiirc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports